module.exports = __webpack_public_path__ + "img/0bf2535.jpg";